import { Component, OnDestroy, OnInit } from '@angular/core';
import { CaptainManageDetailsDAO } from '../../../../../core/services/dao/captainManageDetailsDAO';
import { CaptainManageDetails } from 'anchor-shared/lib/model/entity/captainManageDetails';
import { ContainsSubscriptions } from '../../../../../core/services/interfaces/contains-subscriptions';
import { Observable, Subscription } from 'rxjs/Rx';
import { unsubscribeFromAll } from '../../../../../core/pure-functions/rx-helper';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogsService } from '../../../../../core/services/dialog.service';
import { CustomerDAO } from '../../../../../core/services/dao/customerDAO';
import { CharterDAO } from '../../../../../core/services/dao/charterDAO';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { map } from 'rxjs/operators';
import {
  NgxGalleryAnimation,
  NgxGalleryImageSize,
  NgxGalleryLayout,
  NgxGalleryOrder,
} from '@kolkov/ngx-gallery';
import { NumberFormatterService } from '../../../../../core/services/number.formatter.service';

@Component({
  selector: 'app-captain-checklist',
  templateUrl: './captain-checklist.component.html',
  styleUrls: ['./captain-checklist.component.scss'],
})
export class CaptainChecklistComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  captainManageDetails;
  subs: Subscription[] = [];
  signedPhotoUrl: string;
  charter: Charter;
  customerInDatabase = false;
  templateData$: Observable<{ data: any }>;
  licenseGalleryOptions = [
    {
      imageSize: NgxGalleryImageSize.Cover,
      thumbnailsAutoHide: true,
      thumbnailsColumns: 1,
      thumbnailsRows: 1,
      thumbnailsMargin: 2,
      thumbnailsOrder: NgxGalleryOrder.Row,
      thumbnailsRemainingCount: true,
      imageAnimation: NgxGalleryAnimation.Zoom,
      imageInfinityMove: true,
      previewAnimation: true,
      previewZoom: true,
      previewRotate: true,
      previewInfinityMove: true,
      imageArrowsAutoHide: false,
      thumbnailsArrowsAutoHide: false,
      imageSwipe: true,
      thumbnailsSwipe: true,
      previewSwipe: true,
      previewKeyboardNavigation: true,
      previewCloseOnEsc: true,
      thumbnailActions: [],
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private dialogService: DialogsService,
    private customerDAO: CustomerDAO,
    private captainManageDetailDAO: CaptainManageDetailsDAO,
    private charterDAO: CharterDAO,
    private userDAO: UserDAO,
    private router: Router,
    private readonly numFormatter: NumberFormatterService,
  ) {}

  ngOnInit() {
    this.initAsyncData();
  }

  ngOnDestroy() {
    unsubscribeFromAll(this.subs);
  }

  displayYesOrNo(booleanProperty: boolean) {
    return booleanProperty ? 'Yes' : 'No';
  }

  viewImage(imageUrlToOpen: string) {
    this.dialogService.ViewImagesDialog(imageUrlToOpen);
  }

  viewCustomer() {
    this.router.navigate(['manage/admin/user/edit/' + this.charter.userId]);
  }

  private initAsyncData(): void {
    const charterId = this.route.snapshot.params.charterId;

    this.templateData$ = this.charterDAO.loadById(charterId).pipe(
      map((data) => {
        this.charter = data;

        const detailsSub = this.captainManageDetailDAO
          .adminGetCaptainManageDetails(charterId)
          .subscribe((details) => {
            this.captainManageDetails = details;
            console.log(details);

            this.parsePhotos();
            if (
              this.charter.userId &&
              this.captainManageDetails.checkinMethod !== 'Alternative Check-in'
            ) {
              const signedIdPhotoSub = this.customerDAO
                .adminGetSignedResource(
                  this.charter.userId,
                  this.numFormatter.parseJsonIfString(
                    this.captainManageDetails.boardingCustomerId,
                  )['key'],
                )
                .subscribe((signed) => {
                  this.signedPhotoUrl = signed.signedRequest;
                  const findUserSub = this.userDAO
                    .findUserById(this.charter.userId)
                    .subscribe((foundUser) => {
                      if (
                        foundUser &&
                        foundUser.email.toLowerCase() ===
                          this.charter.customerEmail.toLowerCase()
                      ) {
                        this.customerInDatabase = true;
                      }
                    });
                  this.subs.push(findUserSub);
                });
              this.subs.push(signedIdPhotoSub);
            } else {
              const signedGuestPhotoSub = this.customerDAO
                .adminGetSignedResourceForGuestUser(
                  this.numFormatter.parseJsonIfString(
                    this.captainManageDetails.boardingCustomerId,
                  )['key'],
                )
                .subscribe((signed) => {
                  this.signedPhotoUrl = signed.signedRequest;
                });
              this.subs.push(signedGuestPhotoSub);
            }
          });
        this.subs.push(detailsSub);

        return { data };
      }),
    );
  }

  private parsePhotos(): void {
    this.captainManageDetails.startingExteriorPhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.startingExteriorPhotos,
      );
    this.captainManageDetails.startingInteriorPhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.startingInteriorPhotos,
      );
    this.captainManageDetails.endingExteriorPhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.endingExteriorPhotos,
      );
    this.captainManageDetails.endingInteriorPhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.endingInteriorPhotos,
      );
    this.captainManageDetails.startingFuelGaugePhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.startingFuelGaugePhotos,
      );
    this.captainManageDetails.endingFuelGaugePhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.endingFuelGaugePhotos,
      );

    this.captainManageDetails.startingDamagePhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.startingDamagePhotos,
      );

    this.captainManageDetails.refuelingReceiptPhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.refuelingReceiptPhotos,
      );

    this.captainManageDetails.endingDamagePhotos =
      this.numFormatter.parseJsonIfString(
        // @ts-ignore
        this.captainManageDetails.endingDamagePhotos,
      );
  }
}
